'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6;

import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import H4 from 'UIComponents/elements/headings/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import ChecklistItem from 'pricing-pages-unified-ui/components/common/ChecklistItem';
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "CardLayout__StyledCardWrapper",
  componentId: "sc-18r863t-0"
})(["padding:30px 40px;border:1px solid ", ";background-color:", ";min-height:300px;text-align:left;", ";", ";"], BATTLESHIP, OLAF, breakpoint.tablet(_t || (_t = _`
    min-width: 0;
    &&& {
      width: 90%;
      margin: 0 auto;
    }
    > div {
      flex-direction: column;
    }
  `)), breakpoint.phone(_t2 || (_t2 = _`
    &&& {
      width: 100%;
    }
  `)));
const ContentContainer = styled.div.withConfig({
  displayName: "CardLayout__ContentContainer",
  componentId: "sc-18r863t-1"
})(["display:flex;justify-content:space-between;", ""], breakpoint.tablet(_t3 || (_t3 = _`
    flex-direction: column;
  `)));
const InlineListItem = styled.div.withConfig({
  displayName: "CardLayout__InlineListItem",
  componentId: "sc-18r863t-2"
})(["display:flex;align-items:center;&:not(:last-child){margin-right:16px;&::after{margin-left:20px;font-weight:normal;color:", ";content:'|';}}", ";"], BATTLESHIP, breakpoint.tablet(_t4 || (_t4 = _`
    &:not(:last-child) {
      &:after {
        display: none;
      }
    }
  `)));
const CTAsContainer = styled.div.withConfig({
  displayName: "CardLayout__CTAsContainer",
  componentId: "sc-18r863t-3"
})(["width:350px;text-align:center;button,a{width:100%;line-height:25px;}", " ", ""], breakpoint.tablet(_t5 || (_t5 = _`
    margin: auto;
    margin-top: 30px;
  `)), breakpoint.phoneLarge(_t6 || (_t6 = _`
    width: 100%;
  `)));
const Bold = styled.div.withConfig({
  displayName: "CardLayout__Bold",
  componentId: "sc-18r863t-4"
})(["font-weight:600;"]);

const IncludedMerch = ({
  iconSrc,
  message
}) => /*#__PURE__*/_jsxs(InlineListItem, {
  children: [/*#__PURE__*/_jsx(UIImage, {
    className: "display-inline m-right-2",
    height: 13,
    width: 13,
    src: iconSrc,
    responsive: false
  }), /*#__PURE__*/_jsx("b", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    })
  })]
});

const CardLayout = ({
  title,
  descriptionSubtext = null,
  bizObjectives = [],
  includedMerch = [],
  ctasComponent = null
}) => {
  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    children: [/*#__PURE__*/_jsxs(ContentContainer, {
      className: "m-bottom-3",
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          maxWidth: '700px'
        },
        children: [/*#__PURE__*/_jsx(H4, {
          children: title
        }), /*#__PURE__*/_jsx("p", {
          children: descriptionSubtext
        }), /*#__PURE__*/_jsx(Bold, {
          className: "m-bottom-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "recommendedBundles.idealFor"
          })
        }), bizObjectives.map(bizObjectiveText => /*#__PURE__*/_jsx(ChecklistItem, {
          message: bizObjectiveText
        }, bizObjectiveText))]
      }), /*#__PURE__*/_jsx(CTAsContainer, {
        children: ctasComponent
      })]
    }), /*#__PURE__*/_jsx(Bold, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.crmSuite.includesFreeToolsPlus"
      })
    }), /*#__PURE__*/_jsx(UIFlex, {
      wrap: "wrap",
      children: includedMerch.map((merchConfig, i) => /*#__PURE__*/_jsx(IncludedMerch, Object.assign({}, merchConfig), i))
    })]
  });
};

export default CardLayout;